import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Figure from './Figure.js';
import Navbar from './Navbar/index.js';
import Search from './Search/index.js';
import Header from './Header/index.js';
import Cart from './Cart/index.js';
import Blog from './Blog/index.js';
import Toast from './Toast/index.js';
import LanguageModal from './LanguageModal.js';
import PopinNewsletter from './PopinNewsletter.js';
import ProductInfo from './ProductInfo/index.js';
import QuickAddToCartBtn from './QuickAddToCartBtn.js';
import QuickAddToCartPanel from './QuickAddToCartPanel.js';
import KlaviyoNotifyMe from './KlaviyoNotifyMe.js';
import ContestForm from './ContestForm.js';
import Login from './Login.js';
import Addresses from './Addresses.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      Figure,
      PopinNewsletter,
      Header,
      Navbar,
      Cart,
      Search,
      Blog,
      Toast,
      QuickAddToCartPanel,
      KlaviyoNotifyMe,
      ContestForm,
      QuickAddToCartBtn,
      ProductInfo,
      LanguageModal,
      Login,
      Addresses,
      Facets: (app) => importWhenVisible(() => import('./Facets/index.js'), 'Facets', app),
      VariantMedia: (app) =>
        importWhenVisible(() => import('./VariantMedia.js'), 'VariantMedia', app),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}
